/**
 * Generate referral link for a user
 * @param {number|string} userId - The user ID to generate referral link for
 * @returns {string|null} The referral link or null if userId is invalid
 */
const getReferralLink = (userId) => {
    if (!userId) return null;

    let domain = process.env.REACT_APP_REFERRAL_DOMAIN;

    // Fallback to current origin if env variable is not set
    if (!domain && typeof window !== 'undefined') {
        domain = window.location.origin;
    }

    // Final fallback to default domain
    if (!domain) {
        domain = 'https://longhousee.com';
    }

    // Trỏ về trang smart-redirect /tai-app: đã cài app → OS mở app (Universal/App Link),
    // chưa cài → trang tự đẩy về store + giữ mã ref (clipboard + IP) để điền lại sau khi cài.
    return `${domain}/tai-app?ref=${userId}`;
};

export default getReferralLink;

